import { useParams } from "react-router-dom";

import LessonTabs from "@/components/lesson/LessonTabs";
import { COURSES } from "@/data/courseSections";

const LessonHeader = () => {
  const { courseSlug, sectionId, lessonId } = useParams();

  const course = COURSES.find((course) => course.slug === courseSlug);
  const sectionIndex = course?.course.findIndex(
    (section) => section.slug === sectionId,
  );
  if (sectionIndex < 0) {
    return null;
  }
  const section = course?.course[sectionIndex];
  const lessonIndex = section?.lessons.findIndex(
    (lesson) => lesson.slug === lessonId,
  );
  if (lessonIndex < 0) {
    return null;
  }
  const lesson = section?.lessons[lessonIndex];
  return (
    <>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Lesson {sectionIndex + 1}.{lessonIndex + 1}: {section.title}
          </h1>
          <p className="text-gray-600">
            Learn about {lesson.title} in {section.title}
          </p>
        </div>
      </div>

      <LessonTabs />
    </>
  );
};

export default LessonHeader;
